import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarker2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMarker2"><Path d="M14.2061 8.2793L17.7061 9.2793L17.8926 9.33203L21.0605 12.5L11.5 22.0605L8.33203 18.8926L8.2793 18.7061L7.2793 15.2061L7.15723 14.7812L7.46973 14.4697L13.4697 8.46973L13.7812 8.15723L14.2061 8.2793Z" fill="currentColor"/><Path d="M12.5869 7.47461L6.5 13.5605L4.21289 11.2734L4.25488 10.9121L5.42578 0.963867L12.5869 7.47461Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarker2;
